var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-layout"},[_c('div',{staticClass:"md-layout-item md-size-100"},[_c('FileExplorer',{attrs:{"path":"/shippingdata/exportdata"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }